import React, { useState, useEffect } from "react";

import { Button, Card,CardBody,Row, Container,Col, Table} from "reactstrap";
import { useParams } from "react-router-dom";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import EmployeeTxnDetailService from "../HRService/EmployeeTxnDetailService";



const defData = 
{
    "id": 16,
    "name": "rushali lage",
    "dob": "2023-10-04T10:25:23.843",
    "_Gender": 1,
    "gender": "Female",
    "email": "ruhshalilage123@gmail.com",
    "phoneNumber": "9800112233",
    "address": "libali,Bkt",
    "nationality": "Nepali",
    "advanceRecords": [
        {
            "id": 59,
            "_TxnDate": "2022-01-05T00:00:00",
            "txnDate": "2022/01/05",
            "amount": 44.00,
            "ref_No": "78uuuyygdhghe7"
        },
        {
            "id": 70,
            "_TxnDate": "2022-01-01T00:00:00",
            "txnDate": "2022/01/01",
            "amount": 6006.00,
            "ref_No": "emp remarks 66"
        }
    ],
    "productionRecords": [
        {
            "id": 55,
            "_TxnDate": "2022-01-20T00:00:00",
            "production_Date": "2022/01/20",
            "rate": 0,
            "qty": 500.00,
            "ref_No": "20"
        }
    ],
    "shiftingToDockRecords": [
        {
            "id": 61,
            "_TxnDate": "2022-01-12T00:00:00",
            "shifting_Date": "2022/01/12",
            "qty": 777.00,
            "rate": 0,
            "ref_No": "6767"
        }
    ],
    "shiftingToCounterRecords": [
        {
            "id": 68,
            "_TxnDate": "2022-01-01T00:00:00",
            "shifting_Date": "2022/01/01",
            "qty": 0.00,
            "rate": 0,
            "ref_No": "8"
        }
    ],
    "monthlyPayrolls": [
        {
            "id": 81,
            "_TxnDate": "2023-10-08T07:21:07.243",
            "txn_Date": "2023/10/08",
            "salary": 1247.40,
            "ref_No": "90"
        }
    ]
}

const EmployeeWithTxnDetailList = (props) => {
    const { id } = useParams();
    console.log(id);
  const [employeeDetails, setemployeeDetail] = useState(defData);
  const [Draw, setChildDraw] = useState(1);
  async function fetchPosts() {
    try {
      const fetchedPosts = await EmployeeTxnDetailService.view(id);
      console.log("Fetched Posts:", fetchedPosts); // Debugging line
      setemployeeDetail(fetchedPosts);
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  }
 
  

    useEffect(() => {
      fetchPosts();
    }, []);

  

 

  return (
    <div className="page-content">
    <BreadCrumb title="Employee Txn Detail" pageTitle="Employee" />
        <Container fluid>
            <Row>
                <Row>
                    <Col lg={6}>
                         <Card>
                         <span className="placeholder col-12 mb-5 pt- h-1200 bg-success rounded-bottom-3"></span>
                         
                               <CardBody>
                                <div p-2 h-100>
                               <Table>
                <tbody>
                          <tr>
                            <th className="ps-5" scope="row">
                              ID:
                            </th>
                            <td className="text-muted">{employeeDetails.id}</td>
                          </tr>
                          <tr>
                            <th className="ps-5" scope="row">
                              Name:
                            </th>
                            <td className="text-muted">
                              {employeeDetails.name}
                            </td>
                          </tr>
                          <tr>
                            <th className="ps-5" scope="row">
                              Date of Birth:
                            </th>
                            <td className="text-muted">
                              {employeeDetails.dob}
                            </td>
                          </tr>
                          <tr>
                            <th className="ps-5" scope="row">
                              Gender:
                            </th>
                            <td className="text-muted">
                              {employeeDetails.gender}
                            </td>
                          </tr>
                          <tr>
                            <th className="ps-5" scope="row">
                              Email:
                            </th>
                            <td className="text-muted">
                              {employeeDetails.email}
                            </td>
                            </tr>
                            <tr>
                            <th className="ps-5" scope="row">
                              Phone Number:
                            </th>
                            <td className="text-muted">
                              {employeeDetails.phoneNumber}
                            </td>
                          </tr>
                          <tr>
                            <th className="ps-5" scope="row">
                              Address:
                            </th>
                            <td className="text-muted">
                              {employeeDetails.address}
                            </td>
                          </tr>
                          <tr>
                            <th className="ps-5" scope="row">
                              Nationality:
                            </th>
                            <td className="text-muted">
                              {employeeDetails.nationality}
                            </td>
                          </tr>
                         
                        </tbody>
                </Table>
                </div>
                               </CardBody>
                         </Card>
                    </Col>

                    <Col lg={6}>

                   
                
                           <Card>
                           <span className="placeholder col-12 mb-5 pt- h-1200 bg-success rounded-bottom-3"></span>
                                 <CardBody>
                                 <div className="p-2 h-100">
                                 <Table>
                                    <thead className='ml-0 bg-light'>
                                    <th>ID</th>
                                    <th>Adv.TxnDate</th>
                                    <th>Amount</th>
                                    <th>Ref_No</th>
                                     </thead>
                                     <tbody>
                                       {employeeDetails.advanceRecords.map((item) => (
                                       <tr key={item.id} >
                                      <td>{item.id}</td>
                                      <td>{item.txnDate}</td>
                                      <td>{item.amount}</td>
                                      <td>{item.ref_No}</td>
                                      </tr>
                                      ))}
                                      </tbody>
                                     </Table>
                                     </div>
                                 </CardBody>
                           </Card>    

                           <Card>
                           <span className="placeholder col-12 mb-5 pt- h-1200 bg-success rounded-bottom-3"></span>
                                    <CardBody>
                                    <div className="p-2 h-100"> 
                                          <Table className="table-striped">
                                  <thead  className='ml-0 bg-light'>
                                  <tr>
                                 <th>Id</th>
                              <th>Prod.TDate</th>
                              <th>Prod.Date</th>
                              <th>Rate</th>
                              <th>Quant.</th>
                              <th>Ref.R</th>
                              </tr>
                             </thead>
                       <tbody>
                           {employeeDetails.productionRecords.map((item) => (
                             <tr key={item.id}>
                               <td>{item.id}</td>
                               <td>{item._TxnDate}</td>
                               <td>{item.production_Date}</td>
                               <td>{item.rate}</td>
                               <td>{item.qty}</td>
                               <td>{item.ref_No}</td>
                               
                             </tr>
                           ))}
                         </tbody>
                        </Table>
                     </div>
                  </CardBody>
                </Card>      
                </Col>
               
                    

                </Row>
                <Row>
                    <Col lg={4}>
                         
                               <Card>
                               <span className="placeholder col-12 mb-5 pt- h-1200 bg-success rounded-bottom-3"></span>
                                    <CardBody>
                                    <div className="p-2 h-100"> 
                                    <Table>
                
                       
                <thead className='ml-0 bg-light'>
                    <th>ID</th>
                    <th> ShiftingToDock TxnDate</th>
                    <th>Quantity</th>
                    <th>Rate</th>
                    <th>Reference Rate</th>

    
                </thead>
                  <tbody>
                    {employeeDetails.shiftingToDockRecords.map((item) => (
                      <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>{item._TxnDate}</td>
                        <td>{item.qty}</td>
                        <td>{item.rate}</td>
                        <td>{item.ref_No}</td>
                        
                      </tr>
                    ))}
                  </tbody>
         </Table>
                     </div>
                  </CardBody>
                </Card>
                </Col>
                              
                   
                          
              
                
                    <Col lg={4}>
                         <Card>
                         <span className="placeholder col-12 mb-5 pt- h-1200 bg-success rounded-bottom-3"></span>
                               <CardBody>
                               <div className="p-2 h-100"> 
                               <Table>
                
                       
                <thead className='ml-0 bg-light'>
                    <th>ID</th>
                    <th>ShiftingToCounter TxnDate</th>
                    <th>Quantity</th>
                    <th>Rate</th>
                    <th>Reference Rate</th>

    
                </thead >
                  <tbody>
                    {employeeDetails.shiftingToCounterRecords.map((item) => (
                      <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>{item._TxnDate}</td>
                        <td>{item.qty}</td>
                        <td>{item.rate}</td>
                        <td>{item.ref_No}</td>
                        
                      </tr>
                    ))}
                  </tbody>
         </Table> 
         </div>

                               </CardBody>
                         </Card>
                         </Col>
                    
                          

                    <Col lg={4}>
                           <Card>
                           <span className="placeholder col-12 mb-5 pt- h-1200 bg-success rounded-bottom-3"></span>
                                 <CardBody>
          <div className="p-2 h-100">                                       
        <Table>       
                <thead className='ml-0 bg-light'>
                    <th>ID</th>
                    <th>Monthly TxnDate</th>
                    <th>Salary</th>
                    <th>Reference Rate</th>

    
                </thead>
                  <tbody>
                    {employeeDetails.monthlyPayrolls.map((item) => (
                      <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>{item._TxnDate}</td>
                        <td>{item.salary}</td>
                        <td>{item.ref_No}</td>
                        
                      </tr>
                    ))}
                  </tbody>
         </Table>
         </div> 
                                 </CardBody>
                           </Card>

                    </Col>
                </Row>
            </Row>
        </Container>
    </div>


  );
};

export default EmployeeWithTxnDetailList;
